/// <amd-module name="Artifacts/Connect/components/FirstTimeMessage" />
import * as Res from "Artifacts/Connect/Resources";
import { ITool } from "Artifacts/Connect/types/ITool";
import * as React from "react";
import * as StringUtils from "VSS/Core/Util/String";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface IFirstTimeMessageProps {
  /**
   * Class name to apply to the outer element
   */
  className?: string;

  /**
   * Tool whose first time message is being displayed.
   */
  tool: ITool;
}

export interface IFirstTimeMessageOwnProps extends IFirstTimeMessageProps {
  /**
   * List of tools whose first time message have been dismissed.
   */
  onGetTools: () => void;
  onDismiss: () => void;
}

/**
 * Renders first time use message for the user. The message provides a shortcut to the Get the Tools pane
 * or can be dismissed on the current browser.
 */
export const FirstTimeMessageCard: React.FunctionComponent<IFirstTimeMessageOwnProps> = ({
  tool,
  className,
  onGetTools,
  onDismiss,
}) => {
  const message = StringUtils.format(Res.FirstTimeUser, tool.name);
  const buttonProps = [
    {
      text: Res.GetTools_Text,
      onClick: () => onGetTools(),
      role: "button",
    },
  ];

  return (
    <MessageCard
      className={className}
      severity={MessageCardSeverity.Info}
      buttonProps={buttonProps}
      onDismiss={() => onDismiss()}
    >
      {message}
    </MessageCard>
  );
};
